(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["remora-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.rfReady) return;
      root.dataset.rfReady = '1';
      var rtl = getComputedStyle(root).direction === 'rtl';
      if (rtl) root.classList.add('rf--rtl');

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rf-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rf-panel]'));
      var prev = root.querySelector('[data-rf-prev]');
      var next = root.querySelector('[data-rf-next]');
      var all = root.querySelector('[data-rf-all]');
      var track = panels[0] ? panels[0].querySelector('[data-rf-track]') : null;

      function update() {
        if (!prev || !next) return;
        if (!track) { prev.disabled = next.disabled = true; return; }
        var x = Math.abs(track.scrollLeft);
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = x <= 2;
        next.disabled = x >= max - 2;
        var m = track.querySelector('.rf-card__media');
        if (m) root.style.setProperty('--rf-arrow-top', (m.offsetTop + m.offsetHeight / 2) + 'px');
      }

      function stepSize() {
        var s = track.querySelector('.rf__slide');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return s ? s.getBoundingClientRect().width + gap : track.clientWidth;
      }

      function go(dir) {
        if (!track) return;
        var step = stepSize();
        var perView = Math.max(1, Math.floor((track.clientWidth + 1) / step));
        track.scrollBy({ left: step * perView * dir * (rtl ? -1 : 1), behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      panels.forEach(function (p) {
        var t = p.querySelector('[data-rf-track]');
        if (t) t.addEventListener('scroll', function () { if (t === track) update(); }, { passive: true });
      });

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, j) {
            t.classList.toggle('is-active', i === j);
            t.setAttribute('aria-selected', i === j ? 'true' : 'false');
          });
          panels.forEach(function (p, j) { p.hidden = i !== j; });
          track = panels[i] ? panels[i].querySelector('[data-rf-track]') : null;
          if (track) track.scrollLeft = 0;
          if (all && panels[i] && panels[i].dataset.url) all.href = panels[i].dataset.url;
          update();
        });
      });

      window.addEventListener('resize', update);
      update();
    }

    function initAll() { document.querySelectorAll('[data-rf]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-rf]');
      if (r) init(r);
    });
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target.matches && e.target.matches('[data-rf-tab]')) e.target.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
